import { isMesh } from './coalesce';
import { BoundaryEdges, getBoundaryEdges } from './getBoundaryEdges';
import * as THREE from 'three';
import { shoelaceArea } from './shoelaceArea';
import { buildLoops } from './buildLoops';
import { minkowskiOffset2D } from './minkowskiOffset';

const noop = () => true;

export const buildCameraTravelPath = (
  node: THREE.Object3D,
  height: number,
  distance: number,
  filter: (node: THREE.Object3D) => boolean = noop,
) => {
  const edges3D: BoundaryEdges = [];
  node.traverse((child) => {
    if (isMesh(child) && child.geometry && filter(child)) {
      getBoundaryEdges(child.geometry).forEach((be) => edges3D.push(be));
    }
  });

  const loops3D = buildLoops(edges3D);

  if (!loops3D.length) return new THREE.CatmullRomCurve3([], true);
  // Project each loop, measure area, keep the biggest
  let bestArea = 0;
  let bestOffset: THREE.Vector2[] = [];

  loops3D.forEach((loop) => {
    // Project to XZ plane
    const poly2D = loop.map((v) => new THREE.Vector2(v.x, v.z));

    // Optionally compute area (shoelace)
    const area = Math.abs(shoelaceArea(poly2D));
    // If this is the largest, we’ll offset it
    if (area > bestArea) {
      bestArea = area;

      // Offset polygon
      const offset2D = minkowskiOffset2D(poly2D, distance);
      if (offset2D.length > 2) {
        bestOffset = offset2D;
      }
    }
  });

  if (bestOffset.length < 3) return new THREE.CatmullRomCurve3([], true);

  // Convert offset2D back to 3D
  const offset3D = bestOffset.map((p) => new THREE.Vector3(p.x, height, p.y));
  // Create CatmullRom
  return new THREE.CatmullRomCurve3(offset3D, true, 'chordal');
};
